//'use strict';
export default class AppViewController {

    constructor($scope, $state) {

        let vm = this;
        vm.pageTitle = 'Income Growth Opportunities In China';

        $scope.$on('$locationChangeSuccess', function() {

                // $state.go('appView');

        })
    }
}
AppViewController.$inject = ['$scope', '$state'];


// WEBPACK FOOTER //
// ./src/app/app-view/app-view.controller.js